<!-- mettal-3\src\components\View712.vue -->
<template>
  <div :class="[`view-199`, className || ``]">
    <div class="text-256 fontawesome5free-solid-normal-black-20px">
      <svg width="13" height="13" viewBox="0 0 4.5 6.5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.32031 3.58203L1.66406 6.23828C1.46875 6.43359 1.17578 6.43359 1 6.23828L0.550781 5.80859C0.375 5.61328 0.375 5.32031 0.550781 5.14453L2.44531 3.26953L0.550781 1.375C0.375 1.19922 0.375 0.90625 0.550781 0.710938L1 0.261719C1.17578 0.0859375 1.46875 0.0859375 1.66406 0.261719L4.32031 2.91797C4.49609 3.11328 4.49609 3.40625 4.32031 3.58203Z" fill="black" fill-opacity="0.6"/>
      </svg>
    </div>
    <div class="text-257 poppins-semi-bold-thunder-20px">Уроки</div>
    <teacher22 :className="teacher2Props.className" />
  </div>
</template>

<script>
import Teacher22 from "./Teacher22";
export default {
  name: "View712",
  components: {
    Teacher22,
  },
  props: ["className", "teacher2Props"],
};
</script>

<style>
.view-199 {
  height: 30px;
  left: 7px;
  position: absolute;
  top: calc(50% - 528px);
  width: 132px;
  display: flex;
  align-items: center; /* Выравнивание по вертикали */
}

.text-256 {
  position: absolute;
  left: 112px;
  /* Используем flexbox для центрирования SVG внутри контейнера */
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* Устанавливаем центр вращения */
  transform-origin: center center;
  transform: rotate(90deg);
  
  /* Выравниваем по высоте текста */
  top: 50%;
  margin-top: -6.5px; /* Половина высоты SVG (13px / 2) */
}

.text-257 {
  left: 38px;
  letter-spacing: 0;
  line-height: 30px; /* Равно высоте контейнера для вертикального центрирования */
  position: absolute;
  top: 0;
}

.view-199.view-200 {
  top: calc(50% - 526px);
}
</style>